module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("登录")]), _vm._v(" "), _c('div', {
    staticClass: "login-form"
  }, [_c('form', {
    attrs: {
      "action": "#"
    }
  }, [_c('div', {
    staticClass: "user-name common-div"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "type": "text",
      "name": "username",
      "placeholder": "用户名"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "arrowDown",
    attrs: {
      "src": "static/images/arrow-down.png"
    },
    on: {
      "click": function($event) {
        return _vm.showUser()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-pasw common-div"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.isShowUserList) ? _c('div', {
    staticClass: "userList"
  }, _vm._l((_vm.userList), function(item, index) {
    return _c('div', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.chooseUser(item)
        }
      }
    }, [_vm._v(_vm._s(item.username))])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "rememberPassword",
    on: {
      "click": function($event) {
        return _vm.rememberPassword()
      }
    }
  }, [(!_vm.isRemember) ? _c('img', {
    staticClass: "checkImg",
    attrs: {
      "src": "static/images/gouxuan.png"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isRemember) ? _c('img', {
    staticClass: "checkImg",
    attrs: {
      "src": "static/images/gouxuan1.png"
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "text",
    class: {
      'color-0bd38a': _vm.isRemember
    }
  }, [_vm._v("记住密码")])]), _vm._v(" "), _c('div', {
    staticClass: "login-btn",
    on: {
      "click": _vm._login
    }
  }, [_vm._v("用户名及密码登录")]), _vm._v(" "), _c('div', {
    staticClass: "login-btn bg-appStyle",
    on: {
      "click": _vm.authenticationLogin
    }
  }, [_vm._v("统一认证登录")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "eamil-icon common-icon"
  }, [_c('i', {
    staticClass: "icon"
  }, [_vm._v("")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pasw-icon common-icon"
  }, [_c('i', {
    staticClass: "icon"
  }, [_vm._v("")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-307f3318"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Login.vue
// module id = 842
// module chunks = 1